const initialState = { isLoading: false, data: null };
const registrationAccountPending = (state) => ({
  ...state,
  isLoading: true,
  data: null,
});
const registrationAccountFullfilled = (state, payload) => ({
  ...state,
  isLoading: false,
  data: payload?.payload?.data?.data,
});
const registrationAccountRejected = (state) => ({
  ...state,
  isLoading: false,
  data: null,
});

export default function (state = initialState, action) {
  switch (action.type) {
    case "REGISTRATION_PENDING":
      return registrationAccountPending(state, action);

    case "REGISTRATION_FULFILLED":
      return registrationAccountFullfilled(state, action);

    case "REGISTRATION_REJECTED":
      return registrationAccountRejected(state, action);

    default:
      return {
        ...state,
      };
  }
}
